@if (fiatModel.hasDescription) {
  <span>
    @if (fiatModel?.fiat) {
      {{
      fiatModel.description
      | translate
      : [
      +fiatModel.amount
      | euro_to_user_fiat: fiatModel?.fiat
      | fiat_precision_symbol
      : {
      id: fiatModel.id,
      currencies: fiatModel.currency,
      symbol: true,
      customPrecision:
      fiatModel.precision === null ? fiatPrecisionLO : fiatModel.precision
    }
    ]
    }}
  } @else {
    {{
    fiatModel.description
    | translate
    : [
    +fiatModel.amount
    | fiat_precision_symbol
    : {
    id: fiatModel.id,
    currencies: fiatModel.currency,
    symbol: true,
    customPrecision:
    fiatModel.precision === null ? fiatPrecisionLO : fiatModel.precision
  }
  ]
  }}
}
</span>
} @else {
  @if (fiatModel?.stableCoin) {
    {{
    +fiatModel.amount
    | euro_to_user_fiat: fiatModel?.fiat
    | tradable_precision_symbol
    : {
    id: fiatModel?.stableCoin.getId(),
    ignorePrecision: true
  }
  }}
} @else {
  @if (fiatModel?.fiat) {
    {{
    +fiatModel.amount
    | euro_to_user_fiat: fiatModel?.fiat
    | fiat_precision_symbol
    : {
    id: fiatModel.id,
    currencies: fiatModel.currency,
    symbol: true,
    customPrecision: fiatModel.precision === null ? fiatPrecisionLO : fiatModel.precision
  }
  }}
} @else {
  {{
  +fiatModel.amount
  | fiat_precision_symbol
  : {
  id: fiatModel.id,
  currencies: fiatModel.currency,
  symbol: true,
  customPrecision: fiatModel.precision === null ? fiatPrecisionLO : fiatModel.precision
}
}}
}
}
}
